import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { Button, Card, CardContent, CardHeader, CardMedia, Chip, Divider, Grid, Typography, Box, CardActions } from '@mui/material';
import PlanConfirmDialog from './common/PlanConfirmDialog';
import parse, { domToReact } from 'html-react-parser'
import { LoginInfo } from '../App';
import Constants from './common/Constants';

const Plan = (props) => {
    // 翻訳
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲート
    const navigate = useNavigate()
    const location = useLocation()
	const [show,setShow] = useState(false)

	useEffect(() => {

	},[location.pathname])

    function ageLimit(div){
        let list = ["全年齢","PG-12","R-15","R-18","R-18G"]
        return list[div-1]
    }
    return(
    <Grid xs={props.xs || 12} sm={props.sm || 12} md={props.md || 6} lg={props.lg || 4} xl={props.xl || 3} xxl={props.xxl || 3} className='mb-4 p-2'>
        <Card 
            sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                boxShadow: 2,
                margin: '8px',
                '&:hover': {
                    boxShadow: 6,
                    transform: 'translateY(-4px)',
                    transition: 'all 0.3s ease-in-out'
                },
                transition: 'all 0.3s ease-in-out'
            }}
        >
            <CardHeader 
                title={
                    <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 'bold' }}>
                        {props.data.name || "xxxプラン"}
                    </Typography>
                } 
                sx={{ pb: 2, px: 3, pt: 3 }}
            />
            <CardMedia 
                component="img" 
                image={props.data.plan_id === undefined 
                    ? "/img/plan.webp" 
                    : `${ApiFetch.API_PROTOCOL}//${ApiFetch.IMG_HOST}/plan/${props.data.plan_id}.webp?${props.data.update_datetime}`
                } 
                height={180}
                sx={{ 
                    objectFit: 'cover',
                    backgroundColor: 'grey.100'
                }}
            />
            <CardContent sx={{ flexGrow: 1, pb: 2, px: 3 }}>
                <Box 
                    sx={{ 
                        height: '100px', 
                        overflow: 'hidden', 
                        cursor: 'pointer',
                        mb: 3,
                        '&:hover': {
                            color: 'primary.main'
                        }
                    }} 
                    onClick={() => setShow(true)}
                >
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4 }}>
                        {parse((props.data.description || "xxx説明").substring(0,200).replace(/\r|\n|\r\n/g,"<br/>"),{})}
                    </Typography>
                </Box>
                
                <Box sx={{ mb: 3 }}>
                    <Chip 
                        label={`年齢区分：${ageLimit(props.data.age_limit || 1)}`}
                        size="small"
                        variant="outlined"
                        sx={{ fontSize: '11px' }}
                    />
                </Box>
                
                <Divider sx={{ my: 3 }} />
                
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                        <Typography component="span" sx={{ fontSize: '16px', fontWeight: 'normal' }}>
                            {Constants.CURRENCY_UNIT_LEFT}
                        </Typography>
                        {(props.data.amount || "9999").toLocaleString()}
                        <Typography component="span" sx={{ fontSize: '14px', fontWeight: 'normal', color: 'text.secondary' }}>
                            /月
                        </Typography>
                    </Typography>
                </Box>
                
                {loginInfo.userId === undefined || loginInfo.userId !== props.data.user_id ? 
                    <PlanConfirmDialog data={props.data} show={show} setShow={setShow} /> : 
                    ""
                }
            </CardContent>
            
            {loginInfo.userId !== undefined && loginInfo.userId === props.data.user_id && (
                <CardActions sx={{ position: 'absolute', top: 8, right: 8 }}>
                    <Button 
                        variant='contained'
                        size="small"
                        onClick={() => navigate("/manage/plan/"+(props.data.plan_id || ""))}
                        sx={{ 
                            minWidth: 'auto',
                            fontSize: '12px',
                            boxShadow: 1
                        }}
                    >
                        編集
                    </Button>
                </CardActions>
            )}
        </Card>
    </Grid>
    )
}

export default Plan;
